import React from 'react';
import PropTypes from 'prop-types';
import m from 'messages';
import './header.scss';

const Header = ({ type }) => (
    <header className={`header header-${type}`}>
        <h1>
            <a href="https://viewlogies.com">{m.viewlogies}</a>
            {' ' + m.portalName}
        </h1>
    </header>
);

Header.propTypes = {
    type: PropTypes.oneOf(['black', 'white']),
};

export default Header;
